import { inlineMediaQueryMixin, token, spaceMixin } from "@zillow/constellation";
const negativeSpaceMixin = (space) => token({
  spacing: "spacing"
}, ({
  spacing
}) => {
  var _a;
  if (!spacing) {
    return spaceMixin(space);
  }
  let value = 0;
  if ((_a = space == null ? void 0 : space.startsWith) == null ? void 0 : _a.call(space, "-")) {
    const positiveSpace = space.substring(1);
    if (positiveSpace in spacing) {
      value = spacing[positiveSpace];
    }
    return `-${value}px`;
  }
  return spaceMixin(space);
});
const negativeMarginMixin = (props) => {
  const styles = [];
  if ("margin" in props) {
    styles.push(inlineMediaQueryMixin("margin", (mediaProps) => `margin: ${negativeSpaceMixin(mediaProps.margin)(mediaProps)};`)(props));
  }
  if ("marginTop" in props) {
    styles.push(inlineMediaQueryMixin("marginTop", (mediaProps) => `margin-top: ${negativeSpaceMixin(mediaProps.marginTop)(mediaProps)};`)(props));
  }
  if ("marginBottom" in props) {
    styles.push(inlineMediaQueryMixin("marginBottom", (mediaProps) => `margin-bottom: ${negativeSpaceMixin(mediaProps.marginBottom)(mediaProps)};`)(props));
  }
  if ("marginRight" in props) {
    styles.push(inlineMediaQueryMixin("marginRight", (mediaProps) => `margin-right: ${negativeSpaceMixin(mediaProps.marginRight)(mediaProps)};`)(props));
  }
  if ("marginLeft" in props) {
    styles.push(inlineMediaQueryMixin("marginLeft", (mediaProps) => `margin-left: ${negativeSpaceMixin(mediaProps.marginLeft)(mediaProps)};`)(props));
  }
  return styles;
};
export {
  negativeMarginMixin,
  negativeSpaceMixin
};
